<template>
	<div
		:class="{
			'quoted-vs-actual-table--not-empty': !isEmpty,
		}"
	>
		<h3 class="quoted-vs-actual-table__title">
			{{ $t('qvsa_table_title') }}
		</h3>

		<AppFetchHTMLFromMonolith
			:url="Monolith.AJAX_COMPONENT.QUOTED_VS_ACTUAL"
			:params="params"
			:get-html-from-response="getSubComponentHTMLFromResponse"
			:check-if-html-is-empty="checkIfHTMLIsEmpty"
			@response="handleResponse"
		>
			<template #empty>
				<ProjectReportsChartEmptyState
					:illustration-src="
						Assets.PROJECT_REPORTS_QVSA_EMPTY_ILLUSTRATION
					"
					:content="$t('qvsa_table_has_no_data')"
					icon="icon-list-24"
					hide-add-task-button
				/>
			</template>
		</AppFetchHTMLFromMonolith>
	</div>
</template>

<script lang="ts" setup>
import { Assets } from '@/constants/assets';
import { Monolith } from '@/constants/monolith';
import { AppFetchHTMLFromMonolith } from '@/features/App';
import { getSubComponentHTMLFromResponse } from '@/lib/monolith';
import { computed, ref } from 'vue';
import ProjectReportsChartEmptyState from './ProjectReportsChartEmptyState.vue';
import { type Project } from '@/generated/graphql';

/**
 * The Quoted vs Actual table is rendered by the monolith, we just fetch the
 * HTML and put it into the DOM.
 */
const props = defineProps<{
	projectId: Project['id'];
}>();

const params = computed(() => ({
	project_id: props.projectId,
}));

const isEmpty = ref(false);

const checkIfHTMLIsEmpty = (html: string) => {
	const el = document.createElement('html');
	el.innerHTML = html;

	// The HTML from the monolith contains an element with this class name if
	// the QvsA table is empty.
	const emptyStateElements = el.getElementsByClassName(
		'js-quoted-vs-actual-empty'
	);

	return Boolean(emptyStateElements.length);
};

const handleResponse = ({ isEmpty: payloadIsEmpty }: { isEmpty: boolean }) => {
	isEmpty.value = payloadIsEmpty;
};
</script>

<style lang="scss" scoped>
.quoted-vs-actual-table {
	&__title {
		padding: 1.125rem 0 3rem;
	}

	&--not-empty {
		margin-left: -3rem;
		margin-right: -3rem;
		padding-left: 3rem;
		padding-right: 3rem;
	}
}
</style>
